import { render, staticRenderFns } from "./Palenque.vue?vue&type=template&id=5d383052&"
import script from "./Palenque.vue?vue&type=script&lang=js&"
export * from "./Palenque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports